var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBorderLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 6,
    viewBox: "0 0 283 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.012 2.28712H143.752C143.514 0.98737 142.376 0 141.006 0C139.636 0 138.498 0.985186 138.26 2.28712H0V3.30288H138.26C138.498 4.60263 139.636 5.59 141.006 5.59C142.376 5.59 143.514 4.60481 143.752 3.30288H282.012V2.28712Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBorderLine);
export default __webpack_public_path__ + "static/media/LoginBorderLine.dddf274318e7735d85a421d886241bd3.svg";
export { ForwardRef as ReactComponent };